import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Terms from './pages/Terms';
import CodeOfConduct from './pages/CodeOfConduct';
import Privacy from './pages/Privacy';
import Events from './pages/Events';
import AnuragEvent from './pages/AnuragEvent';
import GitamEvent from './pages/GitamEvent';
import PaperSubmission from './pages/PaperSubmission';
import ProjectExpoSubmission from './pages/ProjectExpoSubmission';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster 
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#fff',
              color: '#000',
              fontFamily: 'Outfit, sans-serif',
              fontWeight: 600,
              padding: '16px',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            },
            success: {
              iconTheme: {
                primary: '#DC143C',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#DC143C',
                secondary: '#fff',
              },
            },
          }}
        />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/gitam-university" element={<GitamEvent />} />
          <Route path="/events/anurag-university" element={<AnuragEvent />} />
          <Route path="/events/anurag-university/paper-submission" element={<PaperSubmission />} />
          <Route path="/events/anurag-university/project-expo" element={<ProjectExpoSubmission />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/code-of-conduct" element={<CodeOfConduct />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
